import { FaCampground } from "react-icons/fa";
import { AiOutlineCheck } from "react-icons/ai";
export default function Similar({ similarTours, date }) {
  return (
    <>
      {/* similar */}
      <div className="d-flex  mt-5 align-content-center mx-5">
        <p className="mx-auto" style={{ fontWeight: 900, fontSize: 20, color: "rgb(11, 80, 11)" }}>
          <FaCampground />
          تورهای مشابه
        </p>
      </div>
      <div className="d-flex flex-wrap mt-5 mb-5">
        <div className=" col-lg-4 col-12 mx-auto">
          <div className="card-header Headers border-0 ">
            <p className="fs-5" style={{ verticalAlign: "middle", color: "rgb(11, 80, 11)" }}>
              <span className=" material-icons mt-2 " style={{ verticalAlign: "middle", color: "rgb(11, 80, 11)" }}>
                today
              </span>{" "}
              هم تاریخ
            </p>
          </div>
          <div className="card-body">
            <table className="table similarity">
              <tbody>
                <tr className="tablehead" style={{ width: "fit-content", borderRadius: 50 }}>
                  <th className="TopRight">نام تور</th>
                  <th>جاذبه ها</th>
                  <th className="TopLeft">زمان</th>
                </tr>

                {similarTours.similarDate?.map((value, index) => {
                  return index > 4 || value.main_status != "4" ? (
                    ""
                  ) : (
                    <tr className="first-tr-border">
                      <td>{value.title}</td>
                      <td>
                        {similarTours.attractions.map((attraction) => {
                          return attraction.tour_id == value.id ? attraction.title + " " : null;
                        })}
                      </td>
                      <td>{date(value.stm)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
        <div className="col-lg-4 col-12 mx-auto">
          <div className="card-header Headers border-0">
            <p className="fs-5" style={{ verticalAlign: "middle", color: "rgb(11, 80, 11)" }}>
              <span className="me-1 mt-2" style={{ color: "rgb(11, 80, 11)" }}>
                <AiOutlineCheck></AiOutlineCheck>
              </span>
              <span>هم قیمت</span>
            </p>
          </div>
          <div className="card-body">
            <table className="table similarity">
              <tbody>
                <tr className="tablehead">
                  <th className="TopRight">نام تور</th>
                  <th>جاذبه ها</th>
                  <th className="TopLeft">قیمت</th>
                </tr>

                {similarTours.similarPrice?.map((value, index) => {
                  return index > 4 || value.main_status != "4" ? (
                    ""
                  ) : (
                    <tr className="first-tr-border">
                      <td>{value.title}</td>
                      <td>
                        {" "}
                        {similarTours.attractions.map((attraction) => {
                          return attraction.tour_id == value.id ? attraction.title + " " : null;
                        })}
                      </td>
                      <td>
                        {value.mainprice}
                        تومان
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
        <div className="col-lg-4 col-12 mx-auto">
          <div className="card-header Headers  border-0">
            <p className="fs-5" style={{ verticalAlign: "middle", color: "rgb(11, 80, 11)" }}>
              <span className=" material-icons mt-2" style={{ verticalAlign: "middle", color: "rgb(11, 80, 11)" }}>
                schedule
              </span>{" "}
              هم مدت
            </p>
          </div>
          <div className="card-body">
            <table className="table similarity">
              <tbody>
                <tr className="tablehead">
                  <th className="TopRight">نام تور</th>
                  <th>جاذبه</th>
                  <th className="TopLeft">مدت</th>
                </tr>

                {similarTours.similarInterval?.map((value, index) => {
                  return index > 4 || value.main_status != "4" ? (
                    ""
                  ) : (
                    <tr className="first-tr-border">
                      <td>{value.title}</td>
                      <td>
                        {similarTours.attractions.map((attraction) => {
                          return attraction.tour_id == value.id ? attraction.title + " " : null;
                        })}
                      </td>
                      <td>
                        <div style={{ width: "80px", wordBreak: "break-all", wordWrap: "break-word" }}>{Math.round((value.ftm - value.stm) / 24 / 60 / 60)} روز</div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}
